import { Leaf, Hammer, Truck, Mountain, ShieldCheck, Droplets } from "lucide-react";

export const servicesData = [
  // Residential
  {
    id: "res_garden",
    category: "residential",
    slug: "garden-design-planting",
    icon: Leaf,
    translationKey: "res_garden",
    image: "https://images.unsplash.com/photo-1558905544-3e3563d77899?q=80&w=2070&auto=format&fit=crop"
  },
  {
    id: "res_hardscape",
    category: "residential",
    slug: "hardscaping-patios",
    icon: Hammer,
    translationKey: "res_hardscape",
    image: "https://images.unsplash.com/photo-1761637823407-ef47925c2714?q=80&w=2070&auto=format&fit=crop"
  },
  {
    id: "res_asphalt",
    category: "residential",
    slug: "asphalt-paving",
    icon: Truck,
    translationKey: "res_asphalt",
    image: "https://images.unsplash.com/photo-1621252179027-94459d27d3ee?q=80&w=2070&auto=format&fit=crop"
  },
  {
    id: "res_paveuni",
    category: "residential",
    slug: "pave-uni-pavers",
    icon: Hammer,
    translationKey: "res_paveuni",
    image: "https://images.unsplash.com/photo-1623298317883-6b70254edf31?q=80&w=2070&auto=format&fit=crop"
  },
  {
    id: "res_walls",
    category: "residential",
    slug: "retaining-walls",
    icon: Hammer,
    translationKey: "res_walls",
    image: "https://images.unsplash.com/photo-1596481768453-8befafc2d7ae?q=80&w=2070&auto=format&fit=crop"
  },
  {
    id: "res_cement",
    category: "residential",
    slug: "cement-work",
    icon: Hammer,
    translationKey: "res_cement",
    image: "https://images.unsplash.com/photo-1517649763962-0c623066013b?q=80&w=2070&auto=format&fit=crop"
  },
  {
    id: "res_rock",
    category: "residential",
    slug: "rock-gardens",
    icon: Mountain,
    translationKey: "res_rock",
    image: "https://images.unsplash.com/photo-1587381419916-78fc843a36f8?q=80&w=2070&auto=format&fit=crop"
  },
  {
    id: "res_cedar",
    category: "residential",
    slug: "cedar-hedges",
    icon: Leaf,
    translationKey: "res_cedar",
    image: "https://images.unsplash.com/photo-1501854140884-074bf6b24363?q=80&w=2070&auto=format&fit=crop"
  },
  {
    id: "res_fence",
    category: "residential",
    slug: "residential-fencing",
    icon: Hammer,
    translationKey: "res_fence",
    image: "https://images.unsplash.com/photo-1599427303058-f616305f9caf?q=80&w=2070&auto=format&fit=crop"
  },
  {
    id: "res_drive_seal",
    category: "residential",
    slug: "driveway-sealing",
    icon: ShieldCheck,
    translationKey: "res_drive_seal",
    image: "https://images.unsplash.com/photo-1621252179027-94459d27d3ee?q=80&w=2070&auto=format&fit=crop"
  },
  {
    id: "res_pave_seal",
    category: "residential",
    slug: "pave-uni-sealing",
    icon: ShieldCheck,
    translationKey: "res_pave_seal",
    image: "https://images.unsplash.com/photo-1623298317883-6b70254edf31?q=80&w=2070&auto=format&fit=crop"
  },
  {
    id: "res_wash",
    category: "residential",
    slug: "pressure-washing",
    icon: Droplets,
    translationKey: "res_wash",
    image: "https://images.unsplash.com/photo-1632759368369-5a98076d787d?q=80&w=2070&auto=format&fit=crop"
  },
  
  // Commercial
  {
    id: "com_grounds",
    category: "commercial",
    slug: "corporate-grounds-maintenance",
    icon: Leaf,
    translationKey: "com_grounds",
    image: "https://images.unsplash.com/photo-1764173040050-b7a87824bc22?q=80&w=2070&auto=format&fit=crop"
  },
  {
    id: "com_install",
    category: "commercial",
    slug: "large-scale-installations",
    icon: Hammer,
    translationKey: "com_install",
    image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=80&w=2070&auto=format&fit=crop"
  }
];
